import {Injectable} from '@angular/core';
import {PctConfigModel} from "../../../models/pct-config/pct-config.model";
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteRemConfigRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {}

    async getPctConfigs(): Promise<PctConfigModel[]> {
        const pctConfigs = await this.parametersDatabase.queryObjects<any>(
            `SELECT *
         FROM pct`,
            null,
            []
        );

        return pctConfigs;
    }

}
